import BaseSlotReel from "Engine/slots/reels/BaseSlotReel";
import Utils from "Engine/Utils";
import SymbolsPool from "Engine/slots/symbols/SymbolsPool";
import {Linear, TimelineMax, TweenMax, Back, Sine} from "gsap/TweenMax";
import EntryPoint from "Engine/EntryPoint";

export default class SlotReel extends BaseSlotReel {
    constructor(data, displayData) {
        super(data, displayData);
    }

    init() {
        this.totalSymbolsCount = this.config.reels.topInvisibleSymbolsCount + this.config.reels.symbolsInReel + this.config.reels.bottomInvisibleSymbolsCount;
        for (let i = 0; i < this.totalSymbolsCount; i++) {
            let symbol = SymbolsPool.poolOut(this.possibleSymbols[Utils.getRandomInt(0, this.possibleSymbols.length - 1)], this.id);
            this.addChild(symbol);
            this.symbols.push(symbol);
        }

        this.data.forEach((item, index) => {
            if (item === 2) {
                item = Utils.getRandomInt(3, 12);
            }
            this.symbols[index + this.config.reels.topInvisibleSymbolsCount].changeSymbol(item);
        });
    }

    createTweens() {
        if (this.rollingTween) this.rollingTween.kill();
        if (this.startTween) this.startTween.kill();
        if (this.stopTween) this.stopTween.kill();

        this.rollingTween = TweenMax.to(this.symbols, 0.07, {
            y: '+=' + this.config.symbols.height, repeat: -1, /*paused:true,*/
            ease: Linear.easeNone,
            onRepeat: this.onRollingTweenRepeat,
            onStart: this.onRollingTweenStart,
            callbackScope: this
        });

        this.startTween = new TimelineMax({paused: true});
        this.startTween.to(this.symbols, 0.1, {y: '-=' + this.config.symbols.height / 10, yoyo: true, repeat: 1,
        ease: Sine.easeOut});
        this.startTween.add(this.rollingTween);

        this.stopTween = TweenMax.to(this.symbols, 1, {y: 0, paused: true});
    }

    correctStopTween() {
        this.stopTween = TweenMax.to(this.symbols, EntryPoint.GameSettings.quickSpin ? 0.3 : 0.5, {
            y: '+=' + this.symbols[1].y * -1, paused: true,
            ease: Back.easeOut.config(0.7),
            onComplete: this.onStopTweenComplete,
            onStart: this.onStopTweenStart(),
            callbackScope: this
        });
    }

    stopReel(data, stopType = 'normal') {
        let newData = data.map((value) => {
            if (value === 2) {
                return Utils.getRandomInt(3, 12);
            } else {
                return value;
            }
        });
        super.stopReel(newData, stopType);
    }
}